<template>
  <div>
    <b-modal
      id="create-case-modal"
      ref="case-group-modal"
      centered
      :title="$t('DEBTIA_ADD_GROUP_MODAL')"
      :ok-title="$t('DEBTIA_ADD')"
      :no-close-on-backdrop="true"
      cancel-variant="outline-secondary"
      size="lg"
      @hidden="resetModal"
      @ok="submitHandler"
    >
      <b-overlay
        id="overlay-background"
        :show="loader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-alert
          v-if="errorMsg"
          variant="warning"
          show
        >
          <h4 class="alert-heading">
            {{ $t('DEBITA_ERROR') }}
          </h4>
          <div class="alert-body">
            <span>{{ errorMsg }}</span>
          </div>
        </b-alert>
        <form
          ref="agreementform"
        >
          <validation-observer
            ref="infoRules"
            tag="form"
          >
            <b-row>
              <b-col
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_GROUP_TITLE')"
                  label-for="group-title"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Group Title"
                    rules="required"
                  >
                    <b-form-input
                      id="group-title"
                      v-model="formData.title"
                      :placeholder="$t('DEBTIA_GROUP_TITLE')"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_PREFIX')"
                  label-for="group-prefix"
                >
                  <b-form-input
                    id="prefix"
                    v-model="formData.prefix"
                    :placeholder="$t('DEBTIA_PREFIX')"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_DESCRIPTION')"
                  label-for="group-description"
                >
                  <b-form-textarea
                    id="group-description"
                    v-model="formData.description"
                    rows="8"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_GROUP_STARTING_PROCESS')"
                  label-for="group-starting-process"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Starting Process"
                    rules="required"
                  >
                    <v-select
                      v-model="formData.starting_process_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="processesOptions"
                      :reduce="val => val.value"
                      :clearable="false"
                      input-id="startingProcess"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                class="mb-1 smtp-details-div"
              >
                <div
                  class="d-i-b"
                >
                  <b-form-checkbox
                    v-model="addSmtpDetails"
                    :checked="addSmtpDetails"
                    class="custom-control-primary"
                    name="check-button"
                    switch
                  >
                    <span class="switch-icon-left">
                      <feather-icon icon="CheckIcon" />
                    </span>
                    <span class="switch-icon-right">
                      <feather-icon icon="XIcon" />
                    </span>
                  </b-form-checkbox>
                </div>
                <div
                  class="d-i-b"
                >
                  <label>
                    {{ $t('DEBTIA_ADD_SMTP_DETAILS') }}
                  </label>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-if="addSmtpDetails"
            >
              <b-col sm="12">
                <validation-provider
                  #default="{ errors }"
                  name="Sendgrid Key"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_SENDGRID_KEY')"
                    label-for="sendgrid_key"
                  >
                    <b-form-input
                      id="sendgrid-key"
                      v-model="formData.sendgrid_key"
                      :state="errors.length > 0 ? false:null"
                      type="text"
                      :placeholder="$t('DEBTIA_SENDGRID_KEY')"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col
                md="12"
              >
                <b-form-group
                  :label="$t('DEBTIA_GROUP_SENDER_EMAIL')"
                  label-for="group-sender-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Sender Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="group-sender-email"
                      v-model="formData.sender_email"
                      :placeholder="$t('DEBTIA_GROUP_SENDER_EMAIL')"
                      :state="errors.length > 0 ? false:null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <validation-provider
                  #default="{ errors }"
                  name="Mail From Name"
                  rules="required"
                >
                  <b-form-group
                    :label="$t('DEBTIA_MAIL_FROM_NAME')"
                    label-for="mail-from-name"
                  >
                    <b-form-input
                      id="mail-from-name"
                      v-model="formData.mail_from_name"
                      :state="errors.length > 0 ? false:null"
                      type="text"
                      :placeholder="$t('DEBTIA_MAIL_FROM_NAME')"
                      trim
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
        </form>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, // BFormInvalidFeedback,
  BFormTextarea,
  BFormInput,
  // BFormDatepicker,
  BFormCheckbox,
  // BCardText,
  BAlert, BOverlay,
  // BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import axios from '@axios'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import constants from '@/app-configs/constants'
import i18n from '@/libs/i18n'
import axiosemail from '../../libs/axiosemail'

export default {
  components: {
    BOverlay,
    BAlert,
    BRow,
    BCol,
    // BFormInvalidFeedback,
    BFormInput,
    BFormGroup,
    // BFormInput,
    vSelect,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    // BCardText,
    // BFormDatepicker,
    // BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  props: {
    processesOptions: {
      type: Array,
      required: true,
    },
    groupData: {
      type: Object,
      required: true,
    },
    reloadMethod: {
      type: Function,
      required: true,
    },
    standardProcess: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      errorMsg: '',
      loader: false,
      required,
      email,
      formData: {},
      groupId: 0,
      communication_client_id: '',
      communication_secret: '',
      addSmtpDetails: false,
    }
  },
  watch: {
    groupData: {
      handler() {
        this.formData = { ...this.groupData }
        if (this.formData.sender_email) {
          this.addSmtpDetails = true
        }
        console.log('groupData', this.groupData)
        // this.getApiSettings()
        // if (this.groupId > 0) {
        //   this.getMailConfigurations(this.groupId)
        // }
      },
    },
    addSmtpDetails: {
      handler() {
        if (!this.addSmtpDetails) {
          this.formData.sender_email = ''
          this.formData.sendgrid_key = ''
          this.formData.mail_from_address = ''
          this.formData.mail_from_name = ''
        }
      },
    },
  },
  created() {
    this.getApiSettings()
  },
  methods: {
    getApiSettings() {
      axios.get('/api-token/default?module=communication').then(settings => {
        if (settings.status) {
          this.communication_client_id = settings.data.data.client_id
          this.communication_secret = settings.data.data.secret
        }
      })
    },
    // sendByChange(val) {
    //   if (val === 'email') {
    //     this.emailvalue = this.mainDebtorEmail
    //   } else {
    //     this.phonenumber = this.mainDebtorPhone
    //   }
    // },
    makeFailureToast(error) {
      this.ApiSettingloader = false
      this.$bvToast.toast(error.response.data.message, {
        title: 'Failed',
        variant: 'danger',
        solid: false,
      })
    },
    resetModal() {
      this.addSmtpDetails = false
      this.formData = {
        title: '',
        prefix: '',
        description: '',
        starting_process_id: this.standardProcess,
        sender_email: '',
        sendgrid_key: '',
        mail_from_address: '',
        mail_from_name: '',
      }
    },
    submitHandler(evt) {
      evt.preventDefault()
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            this.loader = true
            let url = ''
            if (this.groupData.id === 0) {
              url = '/add-debt-case-group'
            } else {
              url = '/edit-debt-case-group'
            }
            // this.email_setting_values.mail_from_address = this.formData.sender_email
            axios.post(url, this.formData).then(response => {
              if (response.status) {
                this.loader = false
                this.addSmtpDetails = false
                // this.email_setting_values.group_id = response.data.data.id
                // this.postEmailSettingValues()
                this.$refs['case-group-modal'].hide()
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: i18n.t('DEBTIA_SUCCESS'),
                    icon: 'CoffeeIcon',
                    variant: 'primary',
                    text: i18n.t('DEBTIA_CASE_GROUP_ADDED_MSG'),
                  },
                })
                this.reloadMethod()
              }
            }).catch(error => {
              this.loader = false
              console.log('error ', error)
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Error',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: i18n.t('DEBTIA_CASE_GROUP_NOT_ADDED_MSG'),
                },
              })
            })
          } else {
            this.loading = false
            reject()
          }
        })
      })
    },
    async getMailConfigurations(groupId) {
      const headers = {
        clientId: this.communication_client_id,
        secret: this.communication_secret,
      }
      await axiosemail.get(`/v1/email/get-user-mail-configs?groupId=${groupId}`, { headers }).then(settings => {
        if (settings.status) {
          this.email_setting_values.id = typeof settings.data.data === 'undefined' ? 0 : settings.data.data.id
          this.email_setting_values.sendgrid_key = settings.data.data.sendgrid_key
          this.email_setting_values.mail_from_address = settings.data.data.mail_from_address
          this.email_setting_values.mail_from_name = settings.data.data.mail_from_name
          this.email_setting_values.group_id = settings.data.data.group_id
        }
      }).catch(error => {
        console.log('error', error)
        // if (err.response.data.message) {
        //   this.alertErrors.push(err.response.data.message)
        // }
        // this.makeFailureToast(error)
      })
    },
    postEmailSettingValues() {
      const headers = {
        clientId: this.communication_client_id,
        secret: this.communication_secret,
      }
      this.ApiSettingloader = true
      let url = ''
      if (this.email_setting_values.id > 0) {
        url = 'v1/email/update-mail-configs'
      } else {
        url = 'v1/email/save-mail-configs'
      }
      axiosemail.post(url,
        { ...this.email_setting_values }, {
          headers,
        }).then(response => {
        if (response.status) {
          this.ApiSettingloader = false
          this.makeSuccessToast()
        }
      }).catch(error => {
        console.log('error', error)
        // if (err.response.data.message) {
        //   this.alertErrors.push(err.response.data.message)
        // }
        // this.makeFailureToast(error)
      })
    },
  },
  // mounted() {
  //   this.showModal()
  // },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.optionsClass {
  margin-bottom: 10px;
}

.d-i-b {
  display: inline-block;
}

.smtp-details-div {
  border-top: 1px solid #d8d6de;
  border-bottom: 1px solid #d8d6de;
  padding: 10px;
  margin-top: 10px;
}
</style>
